import { breakpoints } from "../../tokens/size";
import { v2Colors } from "../../tokens/color";
export const defaultColor = v2Colors.core.slate;
export const defaultCheckedColor = v2Colors.core.innovation;
export const formControlFontSizeStyles = {
    fontSize: '1.6rem',
    [`@media (min-width: ${breakpoints.xl})`]: {
        fontSize: '1.8rem',
    },
    [`@media (max-width: ${breakpoints.lg})`]: {
        fontSize: '1.6rem',
    },
    [`@media (max-width: ${breakpoints.sm})`]: {
        fontSize: '1.4rem',
    },
};
export const formControlStyles = {
    formControl: ({ color = defaultColor, labelColor = defaultColor, borderColor, backgroundColor = v2Colors.core.snow, }) => (Object.assign(Object.assign({}, formControlFontSizeStyles), { backgroundColor: backgroundColor, '& label': {
            color: labelColor,
            fontSize: 'inherit',
        }, '& label.Mui-focused': {
            color: defaultCheckedColor,
        }, '& .MuiInputBase-root': {
            borderRadius: '5px',
            fontSize: 'inherit',
            '& .MuiInputBase-input': {
                color: color,
                fontSize: 'inherit',
            },
            '& fieldset': {
                borderColor: borderColor,
            },
            '&:not(.Mui-disabled):hover fieldset': {
                borderColor: defaultCheckedColor,
            },
            '&.Mui-focused fieldset': {
                borderColor: defaultCheckedColor,
            },
        } })),
    helperText: (helperTextColor) => ({
        color: helperTextColor,
        fontWeight: 400,
        fontSize: '1.4rem',
        [`@media (min-width: ${breakpoints.xl})`]: {
            fontSize: '1.6rem',
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            fontSize: '1.2rem',
        },
    }),
    checkbox: (uncheckedColor = defaultColor, checkedColor = defaultCheckedColor) => (Object.assign(Object.assign({}, formControlFontSizeStyles), { color: uncheckedColor, '&.Mui-checked': {
            color: checkedColor,
        }, '& svg': {
            fontSize: '1.2em',
        } })),
    formControlLabelRoot: (labelPlacement) => ({
        margin: 0,
        alignItems: labelPlacement === 'top' || labelPlacement === 'bottom' ? 'flex-start' : undefined,
    }),
    formControlLabelInput: (labelPlacement) => ({
        transform: labelPlacement === 'top' || labelPlacement === 'bottom' ? 'translateX(-10px)' : undefined,
    }),
    formControlLabelText: (color = defaultColor) => (Object.assign(Object.assign({}, formControlFontSizeStyles), { color: color })),
};
